module.exports = __webpack_public_path__ + "img/WechatIMG172.05ba4809.jpg";